import React from "react";

export default function Youtube() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.7755 9.60042C28.4688 8.44564 27.5652 7.53617 26.4178 7.22753C24.3383 6.66669 15.9993 6.66669 15.9993 6.66669C15.9993 6.66669 7.66049 6.66669 5.58086 7.22753C4.43354 7.53622 3.52993 8.44564 3.22324 9.60042C2.66602 11.6935 2.66602 16.0606 2.66602 16.0606C2.66602 16.0606 2.66602 20.4277 3.22324 22.5208C3.52993 23.6756 4.43354 24.5472 5.58086 24.8558C7.66049 25.4167 15.9993 25.4167 15.9993 25.4167C15.9993 25.4167 24.3382 25.4167 26.4178 24.8558C27.5652 24.5472 28.4688 23.6756 28.7755 22.5208C29.3327 20.4277 29.3327 16.0606 29.3327 16.0606C29.3327 16.0606 29.3327 11.6935 28.7755 9.60042ZM13.2721 20.0256V12.0956L20.2417 16.0607L13.2721 20.0256Z"
        fill="#FF0000"
      />
    </svg>
  );
}
